/**
 * assets/newsletter-popup.js — KITS newsletter popup (delay, dismiss, customer form + Seguno tracking).
 * Submissions use a hidden iframe + native POST (same as footer newsletter): fetch/XHR skips Shopify bot/CAPTCHA and returns errors. return_to adds ?ks_popup_customer_success=1 on success.
 * Seguno: new customers + tags (newsletter, popup-5-percent) sync via Shopify; data-seguno-* on #ks-newsletter-popup for GTM.
 */
(function ksNewsletterPopup() {
  'use strict';

  var STORAGE_KEY = 'ks_newsletter_dismissed';
  var STORAGE_KEY_SUBSCRIBED = 'ks_newsletter_subscribed';
  var POPUP_DELAY_MS = 25000;
  var COOKIE_DAYS = 30;
  var IFRAME_ID = 'ks-newsletter-popup-iframe';
  var IFRAME_NAME = 'ks-newsletter-popup-iframe';
  var SUCCESS_QS = 'ks_popup_customer_success=1';

  var overlay = document.getElementById('ks-popup-overlay');
  var popup = document.getElementById('ks-newsletter-popup');
  var closeBtn = document.getElementById('ks-popup-close');
  var declineBtn = document.getElementById('ks-popup-decline');
  var form = document.getElementById('ks-popup-form');
  var successEl = document.getElementById('ks-popup-success');

  /* Full-page redirect after submit (no iframe target): still mark subscribed + strip query */
  if (window.location.search.indexOf(SUCCESS_QS) !== -1) {
    try {
      localStorage.setItem(STORAGE_KEY_SUBSCRIBED, 'true');
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {}
    if (window.history && window.history.replaceState) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('ks_popup_customer_success');
        var q = u.searchParams.toString();
        window.history.replaceState({}, '', u.pathname + (q ? '?' + q : '') + u.hash);
      } catch (e2) {}
    }
  }

  if (!popup || !overlay) return;

  function pushSignupTracking() {
    var accountId = popup.getAttribute('data-seguno-account-id') || '';
    var formId = popup.getAttribute('data-seguno-form-id') || '';
    /* Removed: window.dataLayer = window.dataLayer || []; - migrated to GTM (single init in theme.liquid) */
    var payload = {
      event: 'newsletter_signup',
      newsletter_source: 'popup',
      discount_offer: '5_percent'
    };
    if (accountId) payload.seguno_account_id = accountId;
    if (formId) payload.seguno_form_id = formId;
    window.dataLayer.push(payload);
  }

  function shouldShowPopup() {
    if (document.body.classList.contains('template-password')) return false;
    var subscribed = localStorage.getItem(STORAGE_KEY_SUBSCRIBED);
    if (subscribed) return false;
    var dismissed = localStorage.getItem(STORAGE_KEY);
    if (dismissed) {
      var t = parseInt(dismissed, 10);
      if (!isNaN(t)) {
        var daysSince = (Date.now() - t) / (1000 * 60 * 60 * 24);
        if (daysSince < COOKIE_DAYS) return false;
      }
    }
    return true;
  }

  function showPopup() {
    overlay.hidden = false;
    popup.hidden = false;
    overlay.offsetHeight;
    popup.offsetHeight;
    overlay.classList.add('is-visible');
    popup.classList.add('is-visible');
    /* Video is lazy: preload="none" in the snippet, started only when the popup actually opens */
    var popupVideo = popup.querySelector('video.ks-popup__video');
    if (popupVideo) {
      var playPromise = popupVideo.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }
    document.body.classList.add('ks-popup-open');
    document.body.style.overflow = 'hidden';
    var emailInput = document.getElementById('ks-popup-email');
    if (emailInput) setTimeout(function () { emailInput.focus(); }, 300);
  }

  function hidePopup(markDismissed) {
    if (markDismissed === undefined) markDismissed = true;
    overlay.classList.remove('is-visible');
    popup.classList.remove('is-visible');
    document.body.classList.remove('ks-popup-open');
    setTimeout(function () {
      overlay.hidden = true;
      popup.hidden = true;
      document.body.style.overflow = '';
    }, 300);
    if (markDismissed) localStorage.setItem(STORAGE_KEY, String(Date.now()));
  }

  function showSuccess() {
    pushSignupTracking();
    var formSection = popup.querySelector('.ks-popup__form-section');
    var videoSection = popup.querySelector('.ks-popup__video-section');
    if (formSection) formSection.hidden = true;
    if (videoSection) videoSection.hidden = true;
    if (closeBtn) closeBtn.hidden = true;
    if (successEl) {
      successEl.hidden = false;
    }
    localStorage.setItem(STORAGE_KEY_SUBSCRIBED, 'true');
    try {
      localStorage.setItem('theme:popup-filled', 'true');
    } catch (e) {}
    setTimeout(function () { hidePopup(false); }, 3000);
  }

  if (closeBtn) closeBtn.addEventListener('click', function () { hidePopup(); });
  if (declineBtn) declineBtn.addEventListener('click', function () { hidePopup(); });
  overlay.addEventListener('click', function () { hidePopup(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-visible')) hidePopup();
  });

  function ensureSubmitIframe() {
    var iframe = document.getElementById(IFRAME_ID);
    if (iframe) return iframe;
    iframe = document.createElement('iframe');
    iframe.id = IFRAME_ID;
    iframe.name = IFRAME_NAME;
    iframe.title = 'Newsletter subscription';
    iframe.setAttribute('tabindex', '-1');
    iframe.setAttribute('aria-hidden', 'true');
    iframe.style.cssText =
      'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';
    iframe.addEventListener('load', onSubmitIframeLoad);
    document.body.appendChild(iframe);
    return iframe;
  }

  function showInlineFormError(message) {
    var existing = document.getElementById('ks-popup-errors');
    if (existing) existing.remove();
    var msg = document.createElement('p');
    msg.className = 'ks-popup__errors';
    msg.id = 'ks-popup-errors';
    msg.setAttribute('role', 'alert');
    msg.textContent = message;
    form.insertAdjacentElement('afterend', msg);
  }

  function onSubmitIframeLoad() {
    var iframe = this;
    var submitBtn = document.getElementById('ks-popup-submit');
    try {
      var win = iframe.contentWindow;
      if (!win || !win.location) {
        if (submitBtn) submitBtn.disabled = false;
        return;
      }
      var href = win.location.href || '';
      if (href.indexOf('about:blank') === 0) return;

      if (href.indexOf(SUCCESS_QS) !== -1) {
        if (submitBtn) submitBtn.disabled = false;
        showSuccess();
        return;
      }

      var doc = win.document;
      if (doc && doc.body) {
        var errEl =
          doc.querySelector('.errors, .form-errors, .note--error, [class*="banner--error"], [class*="form-message--error"]');
        if (errEl && errEl.textContent.trim()) {
          showInlineFormError(errEl.textContent.trim());
          if (submitBtn) submitBtn.disabled = false;
          return;
        }
      }
    } catch (e) {
      /* Cross-origin (e.g. Shopify challenge): user may complete and load again. */
      return;
    }

    if (submitBtn) submitBtn.disabled = false;
  }

  if (form) {
    var submitIframe = ensureSubmitIframe();
    form.setAttribute('target', submitIframe.name);

    form.addEventListener('submit', function () {
      var err = document.getElementById('ks-popup-errors');
      if (err) err.remove();
      var submitBtn = document.getElementById('ks-popup-submit');
      if (submitBtn) submitBtn.disabled = true;
    });
  }

  if (shouldShowPopup()) {
    setTimeout(showPopup, POPUP_DELAY_MS);
  }
})();
